import { planEatApi } from "../../../../planEatApi/PlanEatApi";
import { ICompanyContent } from "../../../../planEatApi/PlanEatFacade";
import { VersionsPage } from "../../components/VersionsPage";

export const VersionsForCompany: React.FC = () => (
    <VersionsPage<ICompanyContent>
        section="companies"
        label="Company"
        idParam="companyId"
        getVersions={planEatApi.getVersionsForCompany}
        nameOf={company => company.companyName}
    />
);
